import { LoadingButton } from '@mui/lab';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type UserCreateConfirmProps = {
  loading: boolean;
  onAbort: () => void;
  onConfirm: () => void;
};

export const UserCreateConfirm = (props: UserCreateConfirmProps) => {
  const { loading, onAbort, onConfirm } = props;
  const { t } = useTranslation(['common']);

  const { trigger } = useFormContext();

  const [showModal, setShowModal] = useState<boolean>(false);

  const handleAbort = () => {
    setShowModal(false);
    onAbort();
  };

  const handleConfirm = () => {
    setShowModal(false);
    onConfirm();
  };

  const handleFormTrigger = async () => {
    const isValid = await trigger();
    if (isValid) setShowModal(true);
  };

  return (
    <>
      <Dialog open={showModal} onClose={handleAbort} maxWidth='sm'>
        <DialogTitle>{t('user:confirmCreate.header')}</DialogTitle>
        <DialogContent>
          <DialogContentText>{t('user:confirmCreate.description')}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleAbort} variant='outlined'>
            {t('common:button.cancel')}
          </Button>
          <Button type='submit' variant='contained' disableElevation onClick={handleConfirm}>
            {t('common:button.confirm')}
          </Button>
        </DialogActions>
      </Dialog>
      <LoadingButton loading={loading} variant='contained' disableElevation onClick={() => handleFormTrigger()}>
        {t('common:button.save')}
      </LoadingButton>
    </>
  );
};
